import type { GlobalNavigationImplementationProps } from "../modules/GlobalNavigation/index.types";

export default (props: GlobalNavigationImplementationProps["headerMenu"]) => ({
	headerMenu: props,
});
